import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export const ApplyFilters = (
  data: { combinedId: number; createdDate: string; referral: string; preferredLocation: string; }[],
  location: string,
  range: string,
  fromDate: string | Date | dayjs.Dayjs,
  toDate: string | Date | dayjs.Dayjs 
) => {
  let filtered = data;
if (location && location !== 'ALL') {
  filtered = filtered.filter(
    item => item.preferredLocation === location
  );
}

    // 2️⃣ Date filter (ONLY if range selected)
  if (!range || range === 'ALL') {
    return filtered; // ✅ ALL-TIME data
  }
  // 2️⃣ Date range filter
  const today = dayjs();
  let startDate: dayjs.Dayjs | undefined = undefined;
  let endDate = today.endOf('day');

  switch (range) {

    case 'LAST_30_DAYS':
      startDate = today.subtract(30, 'day');
      break;
    case 'LAST_60_DAYS':
      startDate = today.subtract(60, 'day');
      break;
    case 'LAST_90_DAYS':
      startDate = today.subtract(90, 'day');
      break;
    case 'LAST_1_YEAR':
      startDate = today.subtract(365, 'day');
      break;
    case 'CUSTOM':
      if (!fromDate || !toDate) {
        return [];
      }
      startDate = dayjs(fromDate);
      endDate = dayjs(toDate).endOf('day');
      break;
    default:
      // No date filter
      return filtered;
  }

  if (startDate) {
    const result = filtered.filter(item =>
      dayjs(item.createdDate).isBetween(
        startDate,
        endDate,
        null,
        '[]'
      )
    );
    return result;
  } else {
    return filtered;
  }
};